<styles-icon-value icon="star">
  <ng-content></ng-content>
</styles-icon-value>
<div class="core-wrapper" *ngIf="isCore" [matTooltip]="generateUnitsTip(element)">core</div>
